import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
export const SwapPairsTitleContainer = styled.div ``;
export const SwapPairTitle = styled(ContentLoader) `
  width: 100%;
  height: 3.3rem;
`;
export const Text = styled.rect `
  height: 3.3rem;
  width: 100%;

  rx: ${({ theme }) => theme.borderRadius.high};
  ry: ${({ theme }) => theme.borderRadius.high};
`;
//# sourceMappingURL=styles.js.map